// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  recaptchaSiteKey: '6Lc-1sUbAAAAAL7JP4MXKwEE13G72mYbe4QBtsDK', // this is from https://stackoverflow.com/questions/3232904/using-recaptcha-on-localhost?rq=1
  google_ApiKey: 'AIzaSyBBSq0u44JSqU3k-mhebaToTv3c5XOHC-k',
  googleAnalyticsTagId: 'GTM-PZZTRPP9',
  production: true,
  auth: {
    login_url: 'id/login',
    approver_login_url: 'id/login/approver',
    searcher_login_url: 'id/login/searcher',
    searcher_request_url: 'id/login/request-search',
    user_login: 'user_login',
    auth_success_url_approver: 'approver',
    auth_success_url_searcher: 'searcher',
    home_url: 'id',
    signup_url: 'id/login/signup',
    forgot_password_url: 'id/login/forgot-password',
    approver_forgot_password_url: 'id/login/approver/forgot-password',
    auth_success_url: 'admin',
    token: 'token',
    token_expiry: 'token_expiry',
    refresh_token: 'refresh_token',
    not_found: 'sessions/404',
    crypto_js_key: 'stratasphere.tech',
    remote_user: '',
  },
  ui: {
    sub_domain: 'sub_domain',
    strata_plan_friendly_name: 'strata_plan_friendly_name',
    body_corporate_id: 'body_corporate_id',
    strata_body_corporate: 'body-corporate',
    property_logo: 'property-logo',
    property_banner: 'property-banner',
    facility_info: 'facility-logos',
    strata_prop_info: 'property-info',
    logged_user_name: '',
  },
  api: {
    root: 'https://dev-bm-api.azurewebsites.net/api',
    auth_approver: 'Auth',
    web_address: 'body-corporate/get-web-address-name',
    plan_list: 'body-corporate/active-plans',
    login: 'auth/login',
    change_profile: 'auth/change-profile',
    remote_login: 'Auth/remote-login',
    searcher_login: 'auth/searcher-login',
    refresh_token: 'auth/refresh-token',
    reset_password: 'auth/reset-password',
    forgot_password: 'auth/forgot-password',
    strata_detail: 'profile/strata',
    site_settings: 'profile/site-settings',
    social_media: 'social-media/strata-plan-number',
    management_details: 'management-details',
    resident_profile: 'profile',
    document_search: 'document-search',
    validate_email: 'profile/validate/email',
    validate_username: 'profile/validate/username',
    update_resident_profile: 'profile',
    lot_detail: 'lot',
    pet: 'pet',
    report: 'report',
    committee: 'committee',
    meeting: 'meeting',
    vehicle: 'vehicle',
    emergency_contact: 'emergency-contact',
    action_request: 'action-item',
    request_type: 'maintenance/category-types',
    category_type: 'maintenance/categories',
    request_status: 'status-count/unit-id',
    request_list: 'summaries/unit-id',
    ai_chat: {
      ask: 'ai-chat/ask',
      public_ask: 'ai-chat/public-ask',
      index: 'ai-chat/index',
    },
    booking_service: {
      facility_names: 'booking/facility-names',
      booking_parameters: 'booking/booking-parameters',
      open_times: 'booking/open-times',
      blackout_dates: 'booking/blackout-dates',
      booked_periods: 'booking/booked-periods',
      book: 'booking',
      cancel: 'booking/cancel',
    },
    notice: {
      download: 'notice/document',
      fetch_all: 'notice',
    },
    dashboard_service: {
      booking_status: 'booking/statuses',
    },
    strata_document_service: {
      documents: 'strata-document',
      levy_notices: 'strata-document/levy-notices',
      categories: 'strata-document/categories',
      download: 'strata-document/download-file',
    },
    meeting_service: {
      meeting_lot_number: 'active-meetings/lot-and-child-lots',
      active_meeting: 'active-meetings',
      proxy_apology: 'proxy-apology',
      active_voting_meetings: 'active-voting-meetings',
      meeting_proxy: 'meeting-proxy',
      check_meeting_started: 'check-meeting-started',
      motion: 'motions',
      motions_proxy: 'motions-proxy',
      motions_proxy_results: 'motions-proxy-results',
      api_key: 'api-key',
    },
    report_service: {
      balance_sheet: 'balance-sheet',
      detailed_expense: 'detailed-expense',
      detailed_revenue: 'detailed-revenue',
      unpaid_contributions: 'unpaid-contributions',
      aged_balance_list: 'aged-balance-list',
      investment_accounts: 'investment-accounts',
      revenue_and_expense_statement: 'revenue-and-expense-statement',
      fee_statement: 'fee-statement',
      financial_snapshot: 'financial-snapshot',
      transaction_invoice:
        'strata-document/transaction-invoice/reference-number',
    },
    commitee_service: {
      members: 'members',
    },
    approver: {
      approver_login: 'approver-login',
      approver_forgot_password: 'approver-forgot-password',
      approver_reset_password: 'approver-reset-password',
      dashboard: {
        payment: 'payment/approval',
        pending_approvals: 'payment/pending-approvals',
        payment_approval: 'payment/pending-approval/reference-number',
        approver_file: 'payment/approver-file',
      },
      history: {
        creditors: 'contacts/creditors',
        approval_history: 'payment/approval-history',
      },
    },
    searcher: {
      dashboard: {
        contractor: 'contacts/contractors',
        category: 'strata-document/categories',
        restricted_category: 'restricted',
        manager: 'property-manager/display-names',
        financial_status: 'lot/financial-status',
        document_search: 'strata-document/search',
        preview_document: 'strata-document/preview',
        download_document: 'strata-document/download-file',
        transaction_invoice:
          'strata-document/transaction-invoice/reference-number',
      },
    },
  },
};
